export const LS_USER = 'userInfo'